<template>
    <div>
        <b-tabs>
            <b-tab title="Información recepción" active>
                <br>
                <b-row>
                    <b-col cols="12" md="6" lg="6">
                        <h5>Recibido el</h5>
                        <label>{{mail.created_at | datetime}}</label>
                        <hr>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <h5>Duración</h5>
                        <label>{{mail.created_at | duration}}</label>
                        <hr>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <h5>Tipo</h5>
                        <label>{{mail.mail_type.name}}</label>
                        <hr>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <h5>Recibido por</h5>
                        <label>{{mail.user.name}}</label>
                        <hr>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <h5>Destino</h5>
                        <label>{{mail.destination.name}}</label>
                        <hr>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <h5>Para</h5>
                        <label>{{!!mail.owner ? mail.owner.name : '-- No especificado --'}}</label>
                        
                        <hr>
                    </b-col>
                    <b-col cols="12" lg="12">
                        <h5 style="text-align:center">
                            <label for="anotation">Notas</label>
                        </h5>
                        <textarea type="text" id="anotation" class="form-control" disabled="true" cols="50" rows="4" v-model="mail.notes"></textarea>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab title="Información entrega" v-if="mail.delivery">
                <br>
                <b-row>
                    <b-col cols="12" md="6" lg="6">
                        <h5>Entregado el</h5>
                        <label>{{mail.delivery.created_at | datetime}}</label>
                        <hr>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <h5>Entregado por</h5>
                        <label>{{mail.delivery.user.name}}</label>
                        <hr>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <h5>Entregado a</h5>
                        <label v-if="mail.delivery.delivered_to">{{mail.delivery.delivered_to}}</label>
                        <label v-else>-- Persona no especificada --</label>
                        <hr>
                    </b-col>
                    <b-col cols="12" lg="12">
                        <h5 style="text-align:center">
                            <label for="anotation">Notas</label>
                        </h5>
                        <textarea type="text" id="anotation" class="form-control" disabled="true" cols="50" rows="4" v-model="mail.delivery.notes"></textarea>
                        <hr>
                    </b-col>
                    <b-col cols="12" lg="12">
                        <h5 style="text-align:center">
                            <label for="anotation">Firma de recibido</label>
                        </h5>
                        <b-img v-if="mail.delivery.signature_url" :src="mail.delivery.signature_url" fluid></b-img>
                        <label style="text-align:center" v-else> -- La entrega no contiene firma de recibido -- </label>
                        <hr>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab title="Fotos" v-if="mail.photos.length">
                <b-carousel
                    id="mails-photos"
                    controls    
                    indicators
                    :interval="4000"
                    v-model="slide"
                >
                    <b-carousel-slide 
                        v-for="photo in mail.photos"
                        :key="photo.id"
                        :img-src="photo.photo_url"
                    />
                </b-carousel>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    props: {
        mail: {
            required: true,
        }
    },
    data(){
        return{
            slide: 1,
        }
    }
}
</script>